import { useState } from 'react';
import { DateTime } from 'luxon';
import type { CampaignDto } from '@/generated/korza-api-client/types.gen';
import { useCampaigns } from '@/hooks/use-campaigns';

/** Unsent campaigns from now on come in one page of 100. */
const NEXT_CAMPAIGN_LIMIT = 100;

/** The `scheduled` campaign with the nearest send date (drafts ignored). */
function nearestScheduled(campaigns: CampaignDto[]): CampaignDto | null {
  return campaigns
    .filter((campaign) => campaign.status === 'scheduled')
    .reduce<CampaignDto | null>(
      (nearest, campaign) =>
        !nearest ||
        DateTime.fromISO(campaign.launchDateTime) <
          DateTime.fromISO(nearest.launchDateTime)
          ? campaign
          : nearest,
      null
    );
}

/**
 * "Próxima campanha" of the Início (HOME-06): `hasBeenSent=false`,
 * `launchDateMin` = now (fixed on mount), 100 per page; the backend lists
 * them `launchDateTime desc`, so the nearest is picked here.
 */
export function useNextScheduledCampaign() {
  const [now] = useState(() => DateTime.now().toISO() ?? undefined);
  const query = useCampaigns(
    { hasBeenSent: 'false', launchDateMin: now },
    NEXT_CAMPAIGN_LIMIT,
    0
  );
  return {
    query,
    /** `undefined` while loading/failed, `null` without a scheduled one. */
    campaign: query.data ? nearestScheduled(query.data.data) : undefined,
  };
}
